//
//
//  Genesys Conversation Panel
//
//

import {GenesysConversation} from "../interfaces.ts";
import {Card, Text as TremorText} from "@tremor/react";
import {formatDateTime} from "../utils.ts";
import CopyableLink from "./CopyableLink.tsx";
import CopyableBox from "./CopyableBox.tsx";

function GenesysConversationPanel({conversation}: {conversation: GenesysConversation}) {
  return (
    // <div className="mt-6 mb-6 grid grid-cols-1 md:grid-cols-2 gap-6">
    <div className="mt-6 mb-6 grid grid-cols-6 gap-6">
        {/* Primer Card: ocupa ambas columnas en md+ */}
        {/* <Card className="w-full md:col-span-2"> */}
        <Card className="col-span-4">
            <div className="grid grid-cols-[150px_1fr] gap-y-4 items-center">
                <TremorText>Conversation ID</TremorText>
                <TremorText className="text-right font-semibold text-black">{conversation.conversation_id}</TremorText>

                <TremorText>Call ID</TremorText>
                <TremorText className="text-right font-semibold text-black">{conversation.call_id}</TremorText>

                <TremorText>Ticket ID</TremorText>
                <TremorText className="text-right font-semibold text-black">{conversation.ticket_id}</TremorText>

                <TremorText>Created At</TremorText>
                <TremorText className="text-right font-semibold text-black">
                    {formatDateTime(new Date(conversation.created_at))}
                </TremorText>

                <TremorText>ANI</TremorText>
                <TremorText className="text-right font-semibold text-black">{conversation.ani}</TremorText>

                <TremorText>DNIS</TremorText>
                <TremorText className="text-right font-semibold text-black">{conversation.dnis}</TremorText>
            </div>
        </Card>

        <Card className="col-span-2">
            <div className="grid grid-cols-[150px_1fr] gap-y-4 items-center">
                <TremorText className="font-semibold text-black">Delivered</TremorText>
                <TremorText className="text-sm text-right whitespace-pre-wrap">
                    {conversation.delivered ? "Yes" : "No"}
                </TremorText>
                <TremorText className="font-semibold text-black">Status</TremorText>
                <TremorText className="text-sm text-right whitespace-pre-wrap">{conversation.status}</TremorText>
                <TremorText className="font-semibold text-black">Language</TremorText>
                <TremorText className="text-sm text-right whitespace-pre-wrap">{conversation.language}</TremorText>
                <TremorText className="font-semibold text-black">Brand</TremorText>
                <TremorText className="text-sm text-right whitespace-pre-wrap">{conversation.brand}</TremorText>
                <TremorText className="font-semibold text-black">Error</TremorText>
                <TremorText className="text-sm text-right whitespace-pre-wrap">{conversation.error_cause}</TremorText>
            </div>
        </Card>

        <Card className="w-full md:col-span-6">
            <div className="overflow-y-auto whitespace-pre-wrap text-sm leading-snug space-y-4">
                <CopyableLink label="Call URL" url={conversation.call_url} />
                <CopyableLink label="Ticket URL" url={conversation.ticket_url} />
            </div>
        </Card>

        <Card className="w-full md:col-span-3">
            <CopyableBox label="Transcript" content={conversation.transcript} />
        </Card>

        <Card className="w-full md:col-span-3 space-y-4">
            <div className="w-full md:col-span-3 max-h-[24rem] overflow-y-auto space-y-4 p-2 bg-gray-50 rounded-md">
                <CopyableBox label="Customer Request" content={conversation.customer_request} />
                <CopyableBox label="Agent Instructions" content={conversation.agent_instructions} />
                <CopyableBox label="Solution" content={conversation.solution} />
                <CopyableBox label="Model" content={conversation.model} />
                <CopyableBox label="Store" content={conversation.store} />
                <CopyableBox label="Purchase Date" content={conversation.purchase_date} />
            </div>
        </Card>
    </div>


  );
}

export default GenesysConversationPanel
